// src/components/demoProjects.js
/* =========================================================
   The free-class demo projects (Admin > Curriculum > Demo sessions).
   Loaded once per page and shared by the class cards and the trial feedback form.
   ========================================================= */
import { useEffect, useState } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_API_BASE_URL;
const cache = {};

const mapDemo = (d) => ({
  id: Number(d.Id),
  name: d.ProjectName || '',
  details: d.ProjectDetails || '',
  link: d.ProjectLink || '',
  plan: Number(d.Plan) || 0, // 1 Little, 2 Junior
  forCourse: d.ForCourse || '',
});

export const loadDemoProjects = (who = 'teacher') => {
  if (!cache[who]) {
    const url = who === 'admin' ? `${API}/api/admin/Curriculum/demo` : `${API}/api/teacher/Curriculum/demo`;
    cache[who] = axios
      .get(url, { headers: { Authorization: `Bearer ${localStorage.getItem('userData')}` } })
      .then((res) => (Array.isArray(res.data) ? res.data.map(mapDemo) : []))
      .catch((err) => {
        delete cache[who];
        throw err;
      });
  }
  return cache[who];
};

export const useDemoProjects = (who = 'teacher') => {
  const [demos, setDemos] = useState([]);
  useEffect(() => {
    let alive = true;
    loadDemoProjects(who)
      .then((list) => alive && setDemos(list))
      .catch(() => alive && setDemos([]));
    return () => {
      alive = false;
    };
  }, [who]);
  return demos;
};

/* The demo made for the course the parent asked for (same level first). */
export const demoForCourse = (demos, course, plan) => {
  if (!course) return null;
  const same = (d) => d.forCourse && d.forCourse.toLowerCase() === String(course).toLowerCase();
  return demos.find((d) => same(d) && d.plan === Number(plan)) || demos.find(same) || null;
};

export const PLAN_LABEL = { 1: 'Little', 2: 'Junior' };
